import { exists } from '@/api'

export interface ReferenceImageMasterUpdateRequest {
  id: number
  title: string
  fileName: string
}

export function ReferenceImageMasterUpdateRequestFromJSON(
  json: any
): ReferenceImageMasterUpdateRequest {
  return ReferenceImageMasterUpdateRequestFromJSONTyped(json)
}

export function ReferenceImageMasterUpdateRequestFromJSONTyped(
  json: any
): ReferenceImageMasterUpdateRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: exists(json, 'id') ? json.id : 0,
    title: exists(json, 'title') ? json.title : '',
    fileName: exists(json, 'file_name') ? json.file_name : ''
  }
}

export function ReferenceImageMasterUpdateRequestToJSON(
  value: ReferenceImageMasterUpdateRequest
): any {
  return {
    id: value.id,
    title: value.title,
    file_name: value.fileName
  }
}
